import { cn } from '@/lib/cn';
import type { ReleaseEnvironment } from '@uchat-team-management/shared';
import type { JSX } from 'solid-js';

/** One color per environment, used everywhere an env is shown as a label. */
const ENV_TONES: Record<ReleaseEnvironment, string> = {
  dev: 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200',
  sit: 'bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-200',
  uat: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200',
  prd: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-200',
};

export interface EnvBadgeProps {
  env: ReleaseEnvironment;
  class?: string;
}

export const EnvBadge = (props: EnvBadgeProps): JSX.Element => (
  <span
    class={cn(
      'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium uppercase',
      ENV_TONES[props.env],
      props.class,
    )}
  >
    {props.env}
  </span>
);
